//@ts-nocheck

import styled, { css } from "styled-components";
import { Paragraph } from "../Typography/Typography.styles";
import { TagSize } from "./Tag.component";
import { Icon } from "../Icon/Icon.styles";

export const TagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.rem(8)};
`

interface TagProps {
  colorScheme?: string;
  $size?: TagSize;
}

export const Tag = styled.div<TagProps>`
  padding: ${({ theme }) => theme.rem(12, 16)};
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.inside};
  border-radius: ${({ theme }) => theme.rem(4)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.rem(8)};

  > ${Paragraph} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary}!important;
  }

  ${({ $size }) => $size === 'small' && css`
    padding: ${({ theme }) => theme.rem(7, 11)};
    border-radius: ${({ theme }) => theme.rem(8)};
    font-size: ${({ theme }) => theme.rem(14)};

    > ${Icon} {
      font-size: ${({ theme }) => theme.rem(18)};
    }
  `}
`